import Diziner from '@diziner/Diziner';
import Logger from '@diziner/Logger';
export class PageHandlers {
    constructor(page) {
        this._page = page;
    }
    register() {
        Logger.instance.debug('PageHandlers.register()');
        this.registerPageScroll();
        this.registerAnchors();
        this.maybeRegisterGform();
        setTimeout(() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            elementorFrontend.onDocumentLoaded();
        }, 0);
        return;
    }
    async onScrollPage() {
        if (this.scrollTop <= 10) {
            Logger.instance.debug('hiding scroll-indicator since we\'re at the top');
            Diziner.instance.issue.scrollProgressIndicator?.hide();
        }
        else {
            Diziner.instance.issue.scrollProgressIndicator?.show();
        }
        const scrollPercentage = this.scrollTop /
            (this.scrollHeight - this.clientHeight) * 100;
        Diziner.instance.issue.scrollProgressIndicator?.
            setProgress(scrollPercentage);
    }
    async registerAnchors() {
        const container = this._page.findHtmlContainer();
        if (!container) {
            return;
        }
        return new Promise((resolve) => {
            const anchors = container.querySelectorAll('[data-target-pageid],' +
                '[data-target-anchor-id],' +
                '[data-href],' +
                '[data-target-anchor-type]');
            anchors.forEach((anchor) => {
                anchor.addEventListener('click', this.onAnchorClick.bind(anchor), { capture: true });
            });
            resolve();
        });
    }
    async onAnchorClick(event) {
        Logger.instance.debug('onAnchorClick');
        return new Promise((resolve, reject) => {
            const issue = Diziner.instance.issue;
            const currentPage = issue.getCurrentPage();
            if (currentPage === null) {
                reject('No currentPage found');
                return;
            }
            const attTargetPageId = this.getAttribute('data-target-pageid');
            const attTargetAnchorId = this.getAttribute('data-target-anchor-id');
            const attTargetAnchorType = this.getAttribute('data-target-anchor-type');
            const attTargetHref = this.getAttribute('data-href');
            Logger.instance.debug('attTargetPageId: ' + attTargetPageId ?? 'null');
            Logger.instance.debug('attTargetAnchorId: ' + attTargetAnchorId ?? 'null');
            Logger.instance.debug('attTargetAnchorType: ' + attTargetAnchorType ?? 'null');
            if (attTargetPageId && attTargetAnchorId && attTargetAnchorId !== '#') {
                issue.navigateToPageId(parseInt(attTargetPageId)).then(() => {
                    console.log(issue.getCurrentPage());
                    issue.getCurrentPage()?.
                        scrollTo(attTargetAnchorId).
                        catch((reason) => {
                        Logger.instance.warning(reason);
                        Logger.instance.warning(issue.getCurrentPage());
                    });
                });
                resolve();
            }
            else if (attTargetPageId) {
                // console.log('PageID: ' + attTargetPageId);
                issue.navigateToPageId(parseInt(attTargetPageId));
                resolve();
            }
            if (attTargetAnchorType) {
                switch (attTargetAnchorType) {
                    case 'previous':
                        currentPage.scrollToPreviousSection(this);
                        break;
                    case 'next':
                        currentPage.scrollToNextSection(this);
                        break;
                    case 'top':
                        currentPage.scrollToTop();
                        break;
                    case 'bottom':
                        currentPage.scrollToBottom();
                        break;
                    case 'first_page':
                        issue.navigateToFirstPage();
                        break;
                    case 'last_page':
                        issue.navigateToLastPage();
                        break;
                }
            }
            if (attTargetHref && attTargetHref.length > 1) {
                issue.navigateToExternal(attTargetHref, this.getAttribute('target'), this.getAttribute('rel'));
            }
            if (this.nodeName === 'A') {
                // TODO: add norel/noref and target blank if not same origin
            }
            else {
                event.preventDefault();
            }
            resolve();
        });
    }
    async registerPageScroll() {
        const pageContainer = this._page.findHtmlContainer();
        if (pageContainer && Diziner.instance.issue.scrollProgressIndicator) {
            pageContainer.removeEventListener('scroll', this.onScrollPage);
            pageContainer.
                addEventListener('scroll', this.onScrollPage.bind(pageContainer));
        }
    }
    async maybeRegisterGform() {
        // @ts-ignore
        if (typeof window.gform === 'undefined') {
            return;
        }
        const container = this._page.findHtmlContainer();
        if (!container) {
            return;
        }
        let gformElements = container.querySelectorAll('[id^=gform_wrapper_]');
        gformElements.forEach((gformElement) => {
            let gformScript = gformElement.
                parentElement?.
                querySelector('script')?.
                innerHTML;
            if (typeof gformScript !== 'undefined' && gformScript.length > 0) {
                eval(gformScript);
            }
        });
    }
}
export default PageHandlers;
